import React, { useEffect, useMemo } from 'react';
import { Input, Select } from 'antd';
import { debounce } from 'lodash';
import { useWidget } from 'components/Widget/useWidget';
import PostbackSelect from 'components/Selects/PostbackSelect';
import AdSelect from 'components/Selects/AdSelect';

const { Option } = Select;

const PostbacksFilters = () => {
  const { setDefaultFilter, defaultFilter, filters } = useWidget();
  const value = defaultFilter.filters?.value?.value || '';
  const type = defaultFilter.filters?.value?.type || 'eq';

  const handleTypeChange = (newType) => {
    setDefaultFilter((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        value: {
          value: value,
          type: newType,
        },
      },
    }));
  };

  const handleFilters = (key, value) => {
    setDefaultFilter((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [key]: value,
      },
    }));
  };

  const inputFields = [
    { key: 'user_id', placeholder: 'User ID' },
    { key: 'event_id', placeholder: 'Event ID' },
    { key: 'session_id', placeholder: 'Session ID' },
    { key: 'click_id', placeholder: 'Click ID' },
    { key: 'transaction_id', placeholder: 'Transaction ID' },
    { key: 'data_1', placeholder: 'Data 1' },
    { key: 'data_2', placeholder: 'Data 2' },
    { key: 'data_3', placeholder: 'Data 3' },
    { key: 'data_4', placeholder: 'Data 4' },
    { key: 'data_5', placeholder: 'Data 5' },
  ];

  return (
    <div className='grid gap-2'>
      <PostbackSelect
        multiple
        value={defaultFilter?.filters?.postback_ids}
        onChange={(ids) => handleFilters('postback_ids', ids)}
      />

      <AdSelect
        multiple
        value={defaultFilter?.filters?.ad_ids ?? defaultFilter?.filters?.ad_ids}
        onChange={(ids) => {
          handleFilters('ad_ids', ids);
        }}
      />

      <Input
        placeholder='Value'
        value={value}
        onChange={(e) => {
          setDefaultFilter((prev) => ({
            ...prev,
            filters: {
              ...prev.filters,
              value: {
                value: e.target.value,
                type: type,
              },
            },
          }));
        }}
        addonAfter={
          <Select value={type || 'eq'} onChange={handleTypeChange} style={{ width: 150 }}>
            <Option value='eq'>Equals</Option>
            <Option value='gt'>Greater Than</Option>
            <Option value='lt'>Less Than</Option>
          </Select>
        }
      />

      <div className='grid gap-1 grid-cols-3'>
        {inputFields.map(({ key, placeholder }) => (
          <Input
            key={key}
            value={defaultFilter?.filters?.[key]}
            placeholder={placeholder}
            onChange={(e) => handleFilters(key, e.target.value)}
          />
        ))}
      </div>
    </div>
  );
};

export default PostbacksFilters;
